/** 登录 */
export const API_LOGIN = 'api/auth/pc/login';

/** 首页 - 公司管理 */
export const API_COMPANY = 'api/basic/company';

/** 员工管理 */
export const API_EMPLOYEE = 'api/auth/admin';

/** 小区管理 */
export const API_VILLAGE = 'api/basic/village';
export const API_EXPORT = 'api/export/village';

/** 用户管理 */
export const API_USER = 'api/user/user';
// 用户充值
export const API_USRE_RECHARFE = 'api/user/recharge';
// 用户缴费
export const API_USER_PAY = 'api/user/pay';

/** 收入明细 */
export const API_PAY = 'api/user/pay';

/** 收入查询 */
export const API_PAY_SUMMARY = 'api/user/paysummary';

/** 修改密码 */
export const API_CHANGE_PWD = 'api/auth/changepwd';




// WEBPACK FOOTER //
// ./src/common/api.js